import axios from 'axios';
import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import ConfirmationDialog from '../../../shared/confirmation-dialog/confirmation-dialog';
import { Dropdown, Form } from 'react-bootstrap';
import { ARCHIVE_PROGRAM, PROGRAM_ENDPOINT } from '../../../constants/program.constants';
import getFormattedDate from '../../../utils/date-format';
import SkeletonCard from '../../../shared/skeleton-loader/skeleton';
import SmoothLoader from '../../../shared/skeleton-loader/smooth-loader';
import { getSetOrgInfo } from '../../../utils/user-info';
import NoDataComponent from '../../../shared/no-data/no-data';

const Programs = () => {

  const confirmationDialogRef = useRef(null);
  const [requestLoader, setRequestLoader] = useState(false);
  const [programsList, setProgramsList] = useState([]);
  const searchField = useRef(null);
  const organizationInfo = getSetOrgInfo();
  const [filterParams, setFilterParams] = useState({
    search_text: "",
    program_status: "active"
  });

  const getAllPrograms = () => {
    setRequestLoader(true);
    axios.get(`${PROGRAM_ENDPOINT}${convertParamsToQuery()}`)
      .then((res) => {
        setTimeout(() => {
          setRequestLoader(false);
        if (res?.data?.status) {
          setProgramsList(res?.data?.response);
        } else {
          setProgramsList([]);
        }
        }, 1000);
      }).catch((error) => {
        setRequestLoader(false);
      });
  }

  const openConfirm = (program) => {
    let text = `Are you sure you want to ${program?.program_status === 'active' ? 'Archive' : 'Restore'} "${program?.title}" program.`;
    confirmationDialogRef.current.setDialogTitle(`Confirm ${program?.program_status === 'active' ? 'Archive' : 'Restore'}`);
    confirmationDialogRef.current.setMessage(text);
    confirmationDialogRef.current.setButtonLabel((program?.program_status === 'active' ? 'Archive' : 'Restore'));
    confirmationDialogRef.current.openDialog(program);
  }
  const toggleArchiveProgram = (item) => {
    confirmationDialogRef.current.setRequestLoader(true);
    axios.put(`${ARCHIVE_PROGRAM}${item?.id}`)
      .then((res) => {
        confirmationDialogRef.current.setRequestLoader(false);
        if (res?.data?.status) {
          let clone = structuredClone(programsList);
          const index = programsList.findIndex(it => it.id === item?.id);
          if (index !== -1) {
            clone.splice(index, 1);
            setProgramsList(clone);
          }
          confirmationDialogRef?.current?.closeDialog();
        } else {
          confirmationDialogRef?.current?.setErrorMessage(res?.data?.message);
        }
      }).catch((error) => {
        confirmationDialogRef.current.setRequestLoader(false);
        confirmationDialogRef?.current?.setErrorMessage("Failed to archive program");
      });
  }

  useEffect(() => {
    getAllPrograms();
  }, [filterParams]);

  const setFilters = (key, value) => {
    setFilterParams({ ...filterParams, [key]: value });
  }

  const convertParamsToQuery = () => {
    let query = "";
    for (var key in filterParams) {
      query += `${query ? '&' : '?'}${key}=${filterParams[key]}`
    }
    return query;
  }

  //html side start
  return (
    <>

      <div className='row' style={{
        minHeight:'100vh'
      }}>
        <div className='col-xl-12'>
          
          <div className='row mb-2'>
            <div className='col-xl-4 col-lg-4 col-md-4 col-12 text-center text-md-start'>
              <h5 className='font-weight-semibold text-black'>Programs & Registration</h5>
            </div>
            <div className='col-xl-8 col-lg-8 col-md-8 col-12 text-center text-md-end'>
              <Link
                to={`/programs/add`}
                 className="add-campaign text-white cursor-pointer pt-2 pb-2 pe-3 px-3">
                   <span>
                    <i className="fa-solid fa-circle-plus mr-5"></i>
                  </span>
                <span className="ms-2 text-white">Add Program</span>
              </Link>
            </div>
          </div>
          <div className='row'>
            <div className='col-xxl-3 col-xl-3 col-md-6 col-12'>
              <div className="form-group">
                <div className="input-group">
                  <input
                    ref={searchField}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setFilters("search_text", searchField?.current?.value);
                      }
                    }}
                    type="text"
                    className="form-control"
                    placeholder="Search by title, subtitle, description"
                  />
                  <button onClick={(e) => {
                    if (searchField?.current?.value) {
                      setFilters("search_text", searchField?.current?.value);
                    }

                  }} type="button" className="btn btn-outline-secondary mb-0">Search</button>
                </div>
              </div>
            </div>
            <div className='col-xxl-3 col-xl-3 col-md-6 col-12'>
              <div className="form-group">
                  <Form.Select onChange={(event) => setFilters('program_status', event.currentTarget.value)}>
                    <option value={"active"}>Active</option>
                    <option value={"archived"}>Archived</option>
                  </Form.Select>
                </div>
            </div>
          </div>
          <hr />
          
                <SmoothLoader  loading={requestLoader} skeleton={<SkeletonCard />}>
          <div className='row position-relative pb-2'>
            {
              programsList?.map((item, index) => {
                return <div key={index} className="col-xl-6 mb-3">
                  <div className="campaign-card">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">
                          <Link
                            to={`/programs/edit/${item?.id}`}
                            className="mb-0 f-16 text-bold"
                          >
                            {item?.title}
                          </Link>
                        </p>
                        <span className="f-12-small">
                          {getFormattedDate(item?.created_at)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-end align-items-baseline">
                        <Link
                          to={`/programs/edit/${item?.id}`}
                          className="me-2 cursor-pointer camp-actions"
                        >
                          <i className="fa-regular fa-pen-to-square f-14"></i>{" "}
                          <span className="d-none d-sm-inline-block f-14">
                            Edit Program
                          </span>
                        </Link>

                        <Dropdown>
                          <Dropdown.Toggle
                            className="mb-0 camp-actions action-toggle"
                            id="dropdown-basic"
                          >
                            <i className="fa-solid fa-ellipsis"></i>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => openConfirm(item)}>
                              {item?.program_status === 'active' ? "Archive" : "Restore"}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>

                    <div className="mt-2 campaign-title">
                      <a
                        className="text-light-blue"
                        href={`${
                          organizationInfo?.organization_short_name}/program/${item?.program_link}`}
                        target={"_blank"}
                      >
                        Preview Program Page {">"}{" "}
                      </a>
                    </div>

                    {/* <div className="mt-3">
                      <div>
                        <span className="f-14">Registrations</span>
                      </div>
                      <div>
                        <Link className="f-16">
                          <span className="text-light-blue mx-1">
                            (0 Registrations)
                          </span>
                        </Link>
                      </div>
                    </div> */}

                    <div className="row mt-3">
                      <div className="col-xl-4 mt-2">
                        <a
                          href={`/layout/email-receipt/programs/${item?.id}`}
                          className="btn-action w-100 d-flex justify-content-start align-items-center cursor-pointer"
                        >
                          <span className="me-2">
                            <i className="fa-solid fa-envelope-open-text"></i>
                          </span>
                          <span>Confirmation Email</span>
                        </a>
                      </div>
                      <div className="col-xl-4 mt-2">
                        <div className='position-relative'>
                          <Link
                            to={`/sharing-donation/${item?.id}/program`}
                            className="btn-action w-100 d-flex justify-content-start align-items-center cursor-pointer">
                            <span className="me-2">
                              <i className="fa-solid fa-qrcode"></i>
                            </span>
                            <span>Sharing</span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="col-xl-6 mt-2">
                        <a
                        onClick={() => openConfirm(item)}
                          className="btn-action w-100 d-flex justify-content-start align-items-center cursor-pointer"
                        >
                          <span className="me-2">
                            <i className={`${item?.program_status === 'active' ? 'fa-solid fa-trash-can' : 'fa-solid fa-rotate-right'}`}></i>
                          </span>
                          <span>{item?.program_status === 'active' ? "Archive" : "Restore"}</span>
                        </a>
                      </div> */}
                      <div className="col-xl-4 mt-2">
                        <div className='position-relative'>
                          <Link
                            to={`/programs/${item?.id}/participants`}
                            className="btn-action w-100 d-flex justify-content-start align-items-center cursor-pointer">
                            <span className="me-2">
                              <i className="fa-solid fa-qrcode"></i>
                            </span>
                            <span>Total Registrants</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              })
            }

            {
                !requestLoader && programsList?.length === 0 ? (
                  <NoDataComponent message={filterParams?.search_text
                        ? "No programs found against this search"
                        : "No Programs Created Yet, Create a program now!"} />
                  // <div className='row'>
                  //   <div className='col-lg-6 col-md-12 offset-lg-3'>
                  //     <div style={{
                  //       boxShadow: 'box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                  //     }} className="card p-5 text-center mt-3">
                  //   <i
                  //     style={{ fontSize: "3rem" }}
                  //     className="fa-solid fa-list-ul"
                  //   ></i>
                  //   <p>
                  //     {filterParams?.search_text
                  //       ? "No programs found against this search"
                  //       : "No Programs Created Yet, Create a program now!"}
                  //   </p>
                  // </div>
                  //   </div>
                  // </div>
                ) : (
                  ""
                )}
          </div>
          </SmoothLoader>
        </div>
      </div>


      <ConfirmationDialog
        ref={confirmationDialogRef}
        executeAction={toggleArchiveProgram}
      />

    </>
  );
  //html side end
}

export default Programs